module.exports = __webpack_public_path__ + "img/logo-green.e851a688.png";